import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {


  WebAPIipAndPort: string = "https://api.blackstoneshipping.com";
  Primary_WebAPIipAndPort: string = "https://api.blackstoneshipping.com";
  // WebAPIipAndPort: string = "https://" + location.hostname + ":44313";



  BSSAPI: string = "/master-api";
  loginID: string;
  userName: string;
  userMail: string;
  lastURL: string = "";
  userId: any;
  roleId: any;
  DefaultOutID: any;
  ouId: any;
  branchId: any;
  branchCode: any;
  OuCode: any;
  tempAgentIDOMS: any;
  temCCIDOMS: any;
  branchCurrency: any;
  tempShipperId: any;
  temppodId: any;
  tempfpodId: any;
  temppolId: any;
  tempcontractcustomerId: any;
  tempagentId: any;
  macAddress: string = "";
  ipAddress: string;
  pageData: any = {};
  allowSaveButton: number;
  allowEditButton: number;
  allowCancelButton: number;
  allowPrintButton: number;
  allowSendEmailButton: number;
  tempCusVendor: string = '';
  sessionId;
  currentComponent: any;
  gstHandler: string = "IN";
  constructor() { }

  TempTypeForParantID: string = "";
  tempTDSGroupID: string = "";
  tempTaxGroupID: string = "";
  tempReceiptcusID: string = "";
  tempisCheque: number = 0;
  tempallBranches: string = "";
  tempbranchCode: any;
  BLISSLoginUserToken: string = "";
  ProjectID: number = 0;
  osVersion: string = "";
  FingerPrintID: string = "";

  gAgentID: number = 0;
  ProfileUrl: any;
  LastLogin: any;

  ProjectId: number = 2557;
  DefaultRoleId: number = 27;
}
